module.exports = __webpack_public_path__ + "img/withImage.2e6bbe44.jpg";